import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowDown, Calculator } from "lucide-react";
import { HeroGameCard } from "./HeroGameCard";
import { useSite } from "@/context/SiteContext";

import { HeroBackdrop } from "./HeroBackdrop";
import PriceBadge from "./PriceBadge";
import HeroGoogleRating from "./HeroGoogleRating";

export default function Hero() {
  const { config, projects } = useSite();
  const names = useMemo(() => projects.filter((p) => !p.is_concept).map((p) => p.client_name || p.title), [projects]);
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-[100svh] lg:min-h-[680px] lg:h-[100svh] lg:max-h-[860px] overflow-hidden">
      <HeroBackdrop src={config.contacts.hero_image} names={names} />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(247,243,235,.6)_0%,rgba(247,243,235,.55)_32%,rgba(247,243,235,.15)_56%,rgba(247,243,235,0)_70%)] max-lg:bg-[linear-gradient(180deg,rgba(247,243,235,.94)_0%,rgba(247,243,235,.86)_55%,rgba(247,243,235,.55)_100%)]" />
      <div className="absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-[#F7F3EB] via-[#F7F3EB]/60 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-[#F7F3EB] via-[#F7F3EB]/55 to-transparent pointer-events-none" />
      <div className="relative container-lm h-full pt-[120px] pb-16 lg:pb-24 flex flex-col lg:flex-row lg:items-center justify-between gap-12">
        <div className="max-w-[560px]">
          <PriceBadge className="mb-6" />
          <h1 data-testid="hero-title" className="font-display text-4xl sm:text-5xl lg:text-[60px] font-semibold leading-[1.08] fade-up">
            Rəqəmsal ideyalarınızı həyata keçiririk
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#2d2c29] leading-relaxed max-w-[460px] fade-up" style={{ animationDelay: ".1s" }}>
            Veb saytlar, mobil tətbiqlər və rəqəmsal həllər. Biznesiniz üçün müasir, sürətli və effektiv məhsullar yaradırıq.
          </p>
          <div className="mt-9 flex flex-wrap gap-3 fade-up" style={{ animationDelay: ".18s" }}>
            <Link to="/#projects" className="btn-dark" data-testid="hero-projects-btn">
              Layihələrimizə baxın <ArrowRight size={16} className="arr" />
            </Link>
            {config.calc?.enabled ? (
              <Link to="/#calculator" className="btn-ghost" data-testid="hero-calc-btn"><Calculator size={16} /> Qiyməti hesablayın</Link>
            ) : (
              <Link to="/#contact" className="btn-ghost" data-testid="hero-contact-btn">Bizimlə danışın</Link>
            )}
          </div>
          <div className="mt-5"><HeroGoogleRating /></div>
        </div>
        <div className="lg:mr-[-10px] flex justify-center lg:justify-end">
          <HeroGameCard />
        </div>
      </div>
      <a href="#projects" data-testid="scroll-down" className="hidden lg:flex absolute bottom-8 left-[max(40px,calc((100vw-1240px)/2+40px))] items-center gap-3 text-xs text-[#171715]/70">
        <ArrowDown size={16} /> Aşağı sürüşdürün
      </a>
    </section>
  );
}
